import { X } from "lucide-react";
import type { ReactElement } from "react";

type TopStatusBarProps = {
  label: string;
  tone: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  closeAriaLabel?: string;
  "data-status"?: string;
};

export function TopStatusBar({
  label,
  tone,
  dismissible = false,
  onDismiss,
  closeAriaLabel = "Close",
  "data-status": dataStatus,
}: TopStatusBarProps): ReactElement {
  return (
    <div
      role="status"
      className={`relative z-50 px-8 py-0.5 text-center text-xs leading-4 font-medium ${tone}`}
      data-status={dataStatus}
    >
      {label}
      {dismissible ? (
        <button
          type="button"
          onClick={onDismiss}
          className="absolute top-1/2 right-1.5 z-10 -translate-y-1/2 cursor-pointer rounded p-0.5 text-white/80 hover:bg-white/15 hover:text-white"
          aria-label={closeAriaLabel}
        >
          <X className="size-3.5" aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
